<template>
  <div>
    <el-select :value="value" value-key="key" :filterable="true" :size="size" :disabled="disabled" :placeholder="placeholder" @input="change($event)" :clearable="true">
      <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      emptyValue: {key: 1},
      placeholder: null,
      options: [{key: 0, value: '待审批'}, {key: 1, value: '审批通过'}, {key: 2, value: '审批不通过'}]
    }
  },
  props: ['value', 'config', 'size', 'disabled', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    if (this.config) {
      this.placeholder = this.config[0]
      this.options = this.config[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PublicSelect.vue